import React from "react";
import configData from "config/config.json";
import { Link } from "react-router-dom";

function storeItemListColumn(data: { showActions?: boolean } = {}) {
  const { showActions = true } = data;

  const cols = [
    {
      id: "_id",
      label: `Store ID`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "type",
      label: `Type`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "purchaseMethod",
      label: `Purchase Mthd.`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "pbfCoin",
      label: `PBF Coin`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "buyPrice",
      label: `Buy Price`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "bonus",
      label: `Bonus`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "isDisabledText",
      label: "Is Disabled?",
      type: "boolean",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    // {
    //   id: "bonusTxt",
    //   label: `Bonus Txt`,
    //   type: "string",
    //   isSortable: true,
    //   alignHead: "center",
    //   alignBody: "center",
    // },
    // {
    //   id: "buyCoins",
    //   label: `Buy Coins`,
    //   type: "string",
    //   isSortable: true,
    //   alignHead: "center",
    //   alignBody: "center",
    // }
  ];

  // if (showPreview) {
  //   cols.push({ id: "thumbnail", label: "Preview" });
  // }

  if (showActions) {
    cols.push({ id: "actions", label: "Actions" } as any);
  }

  return cols;
}

export const storeBannersTableCols = (params = {}) => {
  return [
    {
      id: "_id",
      label: `SB. ID`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
          id: "copiedFrom",
          label: `Copied From`,
          type: "string",
          isSortable: true,
          alignHead: "center",
          alignBody: "center",
          renderCell: (row: any) => {
            const id = row?.copiedFrom;
            if (!id || id === "-") return "-";
    
            const url = configData.routes.storeBanners.edit.replace(":id", id);
    
            return React.createElement(
              Link,
              {
                to: url,
                target: "_blank",
                onClick: (e: any) => e.stopPropagation(),
                style: {
                  color: "#007bff",
                  textDecoration: "underline",
                  cursor: "pointer",
                  opacity: 1,
                },
              },
              id,
            );
          },
        },
    {
      id: "order",
      label: `Store Order`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "title",
      label: `Title`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "body",
      label: `Body`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "isActiveText",
      label: `Is Active?`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    {
      id: "textColor",
      label: `Text Color`,
      type: "string",
      isSortable: true,
      alignHead: "center",
      alignBody: "center",
    },
    { id: "thumbnail", label: "Preview" },
    {
      id: "actions",
      label: "Actions",
    },
  ];
};

export { storeItemListColumn };
